<!-- =========================================================================================
  File Name: ResourceCreateTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div slot="no-body" class="tabs-container px-6">
		<div class="mb-2" style="border: 1px solid #e4e4e4; border-radius: 10px">
			<floating-buttons
				:titleHeader="$t('BreakTable.Action')"
				:cancelText="$t('MODULE_PERMISSION.Cancel')"
				:disabledSave="!validateForm"
				:saveText="$t('Save')"
				@save="save_changes"
				@cancel="$router.push({name: 'app-resources-list'})"
			/>
		</div>
		<vx-card :cardBorder="true" :noShadow="true" :title="$t('GeneralInformation')">
			<div class="vx-row">
				<div class="vx-col w-full">
					<form>
						<div class="vx-row">
							<div class="vx-col md:w-1/3 sm:w-1/3 w-full">
								<label class="vs-input--label">{{ $t("Routing.Table.Identification") }}</label>
								<vs-input
									class="w-full"
									v-model="resource.identification"
									v-validate="'required'"
									name="identification"
								/>
								<span class="text-danger text-sm" v-show="errors.has('identification')">
									{{ $t("ResourceModule.BasicInfoForm.ValidMessages.Identification") }}</span
								>
							</div>
							<div class="vx-col md:w-1/3 sm:w-1/3 w-full">
								<label class="vs-input--label">{{ $t("Routing.Table.Name") }}</label>
								<vs-input class="w-full" v-model="resource.name" v-validate="'required'" name="name" />
								<span class="text-danger text-sm" v-show="errors.has('name')">
									{{ $t("ResourceModule.BasicInfoForm.ValidMessages.Name") }}</span
								>
							</div>
							<div class="vx-col md:w-1/3 sm:w-1/3 w-full">
								<label class="vs-input--label">{{ $t("MODULE_SOURCE.lastName") }}</label>
								<vs-input
									class="w-full"
									v-model="resource.lastname"
									v-validate="'required'"
									name="lastname"
								/>
								<span class="text-danger text-sm" v-show="errors.has('lastname')">
									{{ $t("ResourceModule.BasicInfoForm.ValidMessages.LastName") }}</span
								>
							</div>
						</div>
						<div class="vx-row mt-4">
							<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
								<label class="vs-input--label">{{ $t("MODULE_SOURCE.User_name") }}</label>
								<vs-input
									class="w-full"
									v-model="resource.username"
									v-validate="'required'"
									name="username"
								/>
								<span class="text-danger text-sm" v-show="errors.has('username')">
									{{ $t("ResourceModule.BasicInfoForm.ValidMessages.Username") }}</span
								>
							</div>
							<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
								<label class="vs-input--label">{{ $t("MODULE_SOURCE.Email") }}</label>
								<vs-input
									class="w-full"
									v-model="resource.email"
									v-validate="'required'"
									name="email"
									disabled
								/>
								<span class="text-danger text-sm" v-show="errors.has('email')">
									{{ $t("ResourceModule.BasicInfoForm.ValidMessages.Email") }}</span
								>
							</div>
						</div>
						<div class="vx-row mt-4">
							<div class="vx-col md:w-1/2 w-full">
								<label class="vs-input--label">{{ $t("MODULE_SOURCE.Select_rol") }}</label>
								<vs-input
									v-show="false"
									name="rol"
									class="d-none"
									v-model="rolObject.value"
									v-validate="'required'"
								/>
								<v-select
									v-model="rolObject"
									class="w-full"
									:loading="rolOptions.length <= 0 ? true : false"
									:clearable="false"
									:searchable="false"
									:options="rolOptions"
									:dir="$vs.rtl ? 'rtl' : 'ltr'"
								/>
								<span class="text-danger text-sm" v-show="errors.has('rol')">{{
									$t("ResourceModule.BasicInfoForm.ValidMessages.Role")
								}}</span>
							</div>
							<div class="vx-col md:w-1/2 w-full">
								<label class="vs-input--label">{{ $t("MODULE_SOURCE.Select_status") }}</label>
								<vs-input
									v-show="false"
									name="status"
									class="d-none"
									v-model="statusObject.value"
									v-validate="'required'"
								/>
								<v-select
									v-model="statusObject"
									class="w-full"
									:loading="statusOptions.length <= 0 ? true : false"
									:clearable="false"
									:searchable="false"
									:options="statusOptions"
									:dir="$vs.rtl ? 'rtl' : 'ltr'"
								/>
								<span class="text-danger text-sm" v-show="errors.has('status')">{{
									$t("ResourceModule.BasicInfoForm.ValidMessages.Status")
								}}</span>
							</div>
						</div>
						<div class="vx-row">
							<vx-card :noShadow="true" :title="$t('AdditionalFields')">
								<template slot="actions">
									<vs-button
										class="ml-2 mr-2 font-bold"
										color="primary"
										type="flat"
										icon-pack="feather"
										icon="icon-plus"
										@click.prevent="showPrompt()"
										>{{ $t("Add") }}
									</vs-button>
								</template>
								<vs-table :data="propertiesList" noDataText="">
									<template slot="thead">
										<vs-th>{{ $t("Label") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.Type") }}</vs-th>
										<vs-th>{{ $t("Value") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.Actions") }}</vs-th>
									</template>
									<template slot-scope="{data}">
										<vs-tr :key="indextr" v-for="(tr, indextr) in data">
											<vs-td :data="data[indextr].label">{{ data[indextr].label }}</vs-td>
											<vs-td :data="data[indextr].type.value">{{
												data[indextr].type.value
											}}</vs-td>
											<vs-td :data="data[indextr].value">{{ data[indextr].value }}</vs-td>
											<vs-td>
												<feather-icon
													icon="EditIcon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="editSelect(data[indextr], indextr)"
												/>
												<feather-icon
													icon="Trash2Icon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="deleteItem(data[indextr], indextr)"
												/>
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
								<vs-prompt
									:title="$t('PropertyDefinition')"
									:active.sync="showPromptField"
									:acceptText="$t('Accept')"
									:cancelText="$t('Cancel')"
									:is-valid="validFormAdditionalFields"
									@accept="addProperty(property)"
								>
									<div class="vx-row mt-2">
										<div class="vx-col w-full mt-2">
											<small class="date-label cursor-pointer">
												{{ $t("Label") }}: ({{ $t("LabelHelp") }})
												<i
													class="material-icons ml-1 text-center"
													style="font-size: 14px"
													:title="$t('AcceptsNumbersAndTheDashSign')"
												>
													info
												</i>
											</small>
											<vs-input
												v-model.trim="property.label"
												class="w-full"
												name="label"
												:vs-placeholder="$t('Label')"
												:placeholder="$t('Label')"
												:disabled="isUpdate"
												@keypress="validateKeyAdditionalInfo"
											/>
										</div>
										<div class="vx-col w-full">
											<small class="date-label">{{ $t("ResourceModule.Create.Type") }}</small>
											<v-select
												v-model="property.type"
												name="type"
												:options="type"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
												:clearable="false"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
													<template v-else>
														{{ $t("NoResultsFound") }}
													</template>
												</template>
											</v-select>
										</div>
										<div class="vx-col w-full mt-2">
											<small class="date-label">{{ $t("Value") }}: ({{ $t("TagValue") }})</small>
											<flat-pickr
												v-if="property.type.value === 'datetime'"
												class="w-full"
												v-model="property.value"
												:placeholder="$t('Select')"
												:config="configdateTimePicker"
											/>
											<vs-input
												v-else
												v-model.trim="property.value"
												class="w-full"
												:type="property.type.value"
												:placeholder="
													property.type.value === 'date' || property.type.value === 'time'
														? ''
														: $t('Value')
												"
												:vs-placeholder="$t('Value')"
											/>
										</div>
									</div>
								</vs-prompt>
							</vx-card>
						</div>
					</form>
				</div>
			</div>
		</vx-card>
	</div>
</template>

<script>
import {ResourceEditMixin} from "@/components/resource/model/ResourceEditMixin";

export default {
	mixins: [ResourceEditMixin],
};
</script>
